module.exports = __webpack_public_path__ + "static/ey-2-d708bea62df839abdf09339e5aec81a8.png";